import type { FirestoreActivityProps } from "types/firestoreFeatures";
import { ColorStyle } from "components/select/lineUtility";
import { DEFAULT_MAP_LAYERS, DEFAULT_MAP_LAYERS_TYPE } from "config/config-general";
import type { MapAreaInputConfigProps } from "types/appFunctionality";

type GetDefaultActivityColorIdProps = {
  activity: FirestoreActivityProps | undefined;
  referencedToMap?: boolean;
};
export const getDefaultActivityColorId = ({
  activity,
  referencedToMap = false,
}: GetDefaultActivityColorIdProps): ColorStyle => {
  const defaultColor = referencedToMap ? "Cyan" : "Red";
  if (!activity || !activity.biomassScreening || !activity.biomassScreening.category)
    return defaultColor;
  // Biomass screening activities get a different default color
  const category = activity.biomassScreening.category;
  switch (category) {
    case "agriculture":
      return "Blue";
    case "forest":
      return "Green";
    case "industryWaste":
      return "Yellow";
    case "infrastructure":
      return "Grey";
    case "nonforest":
      return "Brown";
    default:
      return defaultColor;
  }
};

type GetDefaultActivityCategoriesProps = {
  activity: FirestoreActivityProps | undefined;
  config: MapAreaInputConfigProps;
};

export const getDefaultMapLayer = ({
  activity,
  config,
}: GetDefaultActivityCategoriesProps): DEFAULT_MAP_LAYERS_TYPE => {
  const configuredDefault = config.defaultMapLayer ?? "forest";
  const configuredDefaultAvailable = !["disabled", "hidden"].includes(
    config[configuredDefault],
  );
  const fallback = configuredDefaultAvailable
    ? configuredDefault
    : DEFAULT_MAP_LAYERS.find((layer) => !["disabled", "hidden"].includes(config[layer])) ??
      "forest";

  if (!activity || !activity.biomassScreening || !activity.biomassScreening.category) {
    return fallback;
  }
  const biomassCategory = activity.biomassScreening.category;
  switch (biomassCategory) {
    case "agriculture":
    case "industryWaste":
    case "infrastructure":
    case "nonforest":
      return "other";
    case "forest":
      return "forest";
    default:
      return fallback;
  }
};
